// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1hay7","rootCenter":"LoadMoreObserver_rootCenter__ixqUj","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1aRBo"};